import {AxiosInstance} from 'axios';
import {Test} from '../../models/test';
import {responseHandler} from './response';
import {Exam} from '../../models/exam';
import {Resource, ResourceType} from '../../models/resource';
import {Notification} from "../../models/notification";

export const getNotifications = async (client: AxiosInstance, page?: number) =>
    responseHandler<{
        data: { notifications: Notification[], unread: number },
        count: number
    }>(client.get(`/notifications?page=${page || 1}`), true)

export const markAsRead = async (client: AxiosInstance, notificationId?: string) =>
    responseHandler<void>(client.get(`/notifications/${notificationId}/markAsRead`))

export const markAllAsRead = async (client: AxiosInstance) =>
    responseHandler<void>(client.get(`/notifications/markAllAsRead`))
